import { WalletOutlined } from '@ant-design/icons';
import { Button, Card, Col, Divider, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../../layouts/app.layout';

const { Title, Text } = Typography;

const InsuranceReports = () => {
	const navigate = useNavigate();

	const reportCards = [
		{
			title: 'Insurance Report',
			description: 'Streamlined device wise details for insurance companies visibility.',
			icon: <WalletOutlined className="text-2xl text-emerald-500" />,
			route: '/admin/reports/insurance',
			color: 'border-emerald-200 hover:border-emerald-400',
			bgColor: 'bg-emerald-50',
			disabled: false,
		},
	];

	return (
		<AppLayout
			title="Reports"
			subtitle="Generate and view comprehensive reports for business insights"
		>
			<div className="mb-6">
				<Title
					level={4}
					className="mb-2"
				>
					Available Reports
				</Title>
				<Text type="secondary">Access detailed analytics and insights to make informed business decisions</Text>
			</div>

			<Row gutter={[24, 24]}>
				{reportCards.map((report, index) => (
					<Col
						xs={24}
						sm={12}
						lg={8}
						xl={6}
						key={index}
					>
						<Card
							className={`h-full cursor-pointer shadow-sm transition-all duration-200 hover:shadow-md ${report.color} ${
								report.disabled ? 'opacity-60' : ''
							}`}
							bodyStyle={{ padding: '24px' }}
							onClick={() => !report.disabled && navigate(report.route)}
						>
							<div className={`${report.bgColor} mb-4 rounded-lg p-4 text-center`}>{report.icon}</div>

							<Title
								level={5}
								className="mb-2 text-gray-800"
							>
								{report.title}
							</Title>

							<Text
								type="secondary"
								className="mb-4 block text-sm leading-relaxed"
							>
								{report.description}
							</Text>

							<div className="mt-auto">
								<Button
									type={report.disabled ? 'default' : 'primary'}
									size="small"
									block
									disabled={report.disabled}
									onClick={(e) => {
										e.stopPropagation();
										if (!report.disabled) navigate(report.route);
									}}
								>
									{report.disabled ? 'Coming Soon' : 'View Report'}
								</Button>
							</div>
						</Card>
					</Col>
				))}
			</Row>

			<Divider className="my-8" />

			{/* <Card className="shadow-sm">
				<Title
					level={5}
					className="mb-3"
				>
					Quick Actions
				</Title>
				<div className="flex flex-wrap gap-3">
					<Button
						type="default"
						icon={<FileTextOutlined />}
					>
						Export All Reports
					</Button>
					<Button
						type="default"
						icon={<BarChartOutlined />}
					>
						Schedule Reports
					</Button>
					<Button type="default">Report Settings</Button>
				</div>
			</Card> */}
		</AppLayout>
	);
};

export default InsuranceReports;
